import EfficacySafety from "@components/efficacy-safety";
import * as React from 'react';
export default {
  EfficacySafety,
  React
};